import $ from "jquery";
import { debounce } from "throttle-debounce";

const SELECTOR_CONTAINER = '[data-js="jsPageHeaderSearch"]';
const SELECTOR_CLOSE = '[data-js="jsPageHeaderSearchClose"]';
const SELECTOR_SEARCH = '[data-js="jsPageHeaderSearch"] > div';
const SELECTOR_TITLE =
  '[data-js="pageHeaderSearchLink"] [data-js="jsCollapseTitle"]';
const SELECTOR_BODY =
  '[data-js="jsPageHeaderSearch"] [data-js="jsCollapseBody"]';

const searchLinkField = function () {
  return $(SELECTOR_CONTAINER).find("input");
};

const focus = function () {
  searchLinkField().focus();
};

const blur = function () {
  searchLinkField().blur();
};

const animateCSS = function (element, animation) {
  return new Promise((resolve, reject) => {
    element.addClass(animation);

    // IE is flaky with element.one('animationend', handleAnimationEnd)
    // so set timeout according to duration in _animations.scss
    setTimeout(function () {
      element.removeClass(animation);
      resolve("Animation ended");
    }, 700);
  });
};

const expand = function () {
  $(SELECTOR_BODY).removeAttr("hidden");
  $(SELECTOR_TITLE).attr("aria-expanded", true);
};

const collapse = function () {
  $(SELECTOR_BODY).attr("hidden", "hidden");
  $(SELECTOR_TITLE).attr("aria-expanded", false);
};

const open = async function () {
  $("body").addClass("is-search-open");

  $.when(await animateCSS($(SELECTOR_SEARCH), "fade-in-left")).then(() => {
    expand();
    focus();
  });
};

const close = async function () {
  $("body").removeClass("is-search-open");

  $.when(await animateCSS($(SELECTOR_SEARCH), "fade-out-left")).then(() => {
    collapse();
    blur();
  });
};

const placeholder = debounce(
  250,
  () => {
    const shortPlaceholder = "Enter a keyword, or type of law";
    const longPlaceholder = "Enter a keyword, lawyer name, or type of law";

    if (window.matchMedia("(max-width: 991.98px)").matches) {
      $('input[id="query"]').attr("placeholder", shortPlaceholder);
      $('input[id="query2"]').attr("placeholder", shortPlaceholder);
    } else {
      $('input[id="query"]').attr("placeholder", longPlaceholder);
      $('input[id="query2"]').attr("placeholder", longPlaceholder);
    }
  },
  { atBegin: true },
);

$(document).on(
  "click",
  '[data-js="pageHeaderSearchLink"] > div:first-child',
  function (e) {
    open();
  },
);

$(document).on("click", SELECTOR_CLOSE, function (e) {
  close();
});

$(window).on("resize", placeholder);

$(function () {
  placeholder();
  collapse();
  $(SELECTOR_TITLE).off();
});
